/** Transient staging bucket for browser-direct PDF uploads. Objects are
 *  deleted by the process route after the pipeline runs. */
export const FLOW_UPLOAD_BUCKET = 'flow-document-uploads';

export const FLOW_UPLOAD_MIME = 'application/pdf';
